import {forkJoin, Observable, of as observableOf, Subscription} from 'rxjs';

import {debounceTime, flatMap, map, mergeMap} from 'rxjs/operators';
import {AfterViewInit, OnInit, OnDestroy, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {AppService} from '../../commons/app.service';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatSnackBar} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';

import {
  Dataset,
  Folder,
  FourDService,
  ProcessorAPI,
  Project,
  Transform,
  TransformGroup,
  TransformType
} from '4d-mapper';
import {SearchQueryNode} from 'vasat';

import {ExplorerListComponent} from '../../commons/explorer-list.component'
import {ExplorerTreeComponent} from '../../commons/explorer-tree.component'
import {AppDialog} from '../../commons/dialogs/app-dialog'
import {APIDialog} from '../../commons/dialogs/explorer.dialogs';
import {FormControl} from '@angular/forms';
import {MainService} from '../main.service';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import {MapService} from '../../commons/map.service';
import {HttpClient} from '@angular/common/http';

import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';
import { AlignBoundsDialog } from '../../commons/dialogs/align-bounds/align-bounds.component';
import { UiManagerService } from '@src/app/xs/services/ui/ui-manager.service';
import { AclService } from '@src/app/commons/acl/acl.service';
import { XsIncomingDataService } from '@src/app/xs/services/data/incoming-data.service';

const _ = require('underscore')
const M = require('moment')

declare var google: any;
declare var Dropbox: any;


export interface FileStub {
  valid: boolean
  file?: File
  dataset?: Dataset
}

@Component({
  selector: 'explorer-comp',
  templateUrl: './explorer.component.html',
  styleUrls: ['./explorer.component.scss']
})
export class ExplorerComponent extends AppBaseComponent implements OnInit, OnDestroy, AfterViewInit {


  subs: Subscription[] = []

  dataType: 'Dataset' | 'Transform' = 'Dataset';

  @ViewChild(ExplorerListComponent, {static: false})
  fileListComponent: ExplorerListComponent

  @ViewChild(ExplorerTreeComponent, {static: false})
  treeComponent: ExplorerTreeComponent

  selectedFolder: Folder
  rootFolder: Folder

  files: SearchQueryNode

  type_Dataset = Dataset
  type_Transform = Transform

  adHocs: TransformType[] = []
  adHocF: TransformType[] = []

  folderXforms: TransformType[] = []

  specialActions: TransformType[] = []

  canAddFile: boolean = true
  canAddFolder: boolean
  showProcessor: boolean = false;

  searchCont = new FormControl();


  isSearch: boolean

  @Input('project') project: Project
  @Input('transform_group') transformGroup: TransformGroup

  @Input()
  selectFiles: boolean = true

  @Input('dialog')
  isDialog: boolean = false;

  @Input()
  public bindedPickerCallback: Function;
  private googleFolder: Folder;
  private totalDownloadableItem: number = 0;
  private googleDatasetsList: any[] = [];
  private downloadUrlTried: number = 0;

  @Output()
  folderSelected = new EventEmitter<Folder>()

  @Output()
  filesSelected = new EventEmitter<Dataset[]>()
  private dropboxFolder: Folder;

  @ViewChild('dropboxButton', {static: false}) dropboxButton: ElementRef;
  // private dropboxButton: any;
  private dropboxDatasetsList: any = [];


  selectedTab:string = 'files';

  constructor(public fourD: FourDService, public service: AppService, r: Router, sn: MatSnackBar, d: MatDialog, ar: ActivatedRoute, public incomingData: XsIncomingDataService,
    public translate: TranslateService, public mainService: MainService, private mapService: MapService, private httpClient: HttpClient, 
    applicationEvents:XsApplicationEventsService, public uiManager: UiManagerService, public permissions: AclService) {
    super(service, r, sn, d, applicationEvents)
    this.files = {
      op: 'and',
      items: [{
        col: 'folder', op: '=', isNull: true
      },
        {
          col: 'account', op: '=', val: this.fourD.activeTeam.id
        }
      ]
    }

    this.service.V.registerCacheClass(Folder,[])
    this.service.V.registerCacheClass(Dataset,[])
    // listen out for socket events when folders are updated. If theyre not in casche, dont update anything
    this.subs.push(this.fourD.onSocketCommand('update_folder').subscribe(s => {
      var f = this.service.V.findCached(Folder,s.id)
      if(f)
        f.set(s)
    }))
    // update dataset name and type
    this.subs.push(this.fourD.onSocketCommand('update_dataset').subscribe(s => {
      var f = this.service.V.findCached(Dataset,s.id)
      if(f)
        f.set(s)
    }))
    // refresh the list view on create
    this.subs.push(this.fourD.onSocketCommand('delete_dataset').subscribe(s => {
      if(s.folder && this.treeComponent.selectedFolder && (s.folder.id == this.treeComponent.selectedFolder.id || (!s.folder && !this.treeComponent.selectedFolder)))
        this.fileListComponent.refresh()
    }))
    this.subs.push(this.fourD.onSocketCommand('create_dataset').subscribe(s => {
      if(s.folder && this.treeComponent.selectedFolder && (s.folder.id == this.treeComponent.selectedFolder.id || (!s.folder && !this.treeComponent.selectedFolder)))
        this.fileListComponent.refresh()
    }))
    // tasks
    this.subs.push(
      this.fourD.runningTasksObservable.subscribe(s => {
        //console.log("Enter runningTasksObservable")

        if (s.finished) {
          var ds = this.fileListComponent.dataSource.results.items.find(ds => ds.id == s.task.dataset.id)
          if (ds)
            ds.fetch()
        }
      })
    )

    // uploads
    this.subs.push(
      this.fourD.uploadsRunningObservable.subscribe(s => {
        //console.log("Enter uploadsRunningObservable")
        if (s.finished) {
          var ds = this.fileListComponent.dataSource.results.items.find(ds => ds.id == s.task.dataset.id)
          if (ds)
            ds.fetchObservable().subscribe(res => {
              // Refresh the file list again in case new one was added so it can do the checkPhotoCount properly after fetching dataType value for this dataset
              this.fileListComponent.refresh()
            })
        }
      })
    )

    // filters
    this.subs.push(
      ar.params.subscribe(s => {
        if (s.filter) {
          this.dataType = s.filter;
          this.mainService.dataType = this.dataType;
        }

      })
    )

    // account change (refresh)
    this.subs.push(
      fourD.accountChangeObservable.subscribe(s => {
        // console.log('refreshing')
        if (this.treeComponent)
          this.treeComponent.refresh(false)
        this.selectFolder(null)

      })
    );

    // new folder
    this.subs.push(
      this.mainService.createNewFolder.subscribe(f => {
        this.newFolder(f);
      }),
      /*this.mainService.openGoogleDriveSub.subscribe(_ => {
        this.openGoogleDrive();
      }),*/
      this.mainService.openDropBoxSub.subscribe(_ => {
        this.clickDropBox();
      }),
      this.mainService.renameSub.subscribe(f => {
        this.rename(f);
      }),
      this.mainService.moveFolderSub.subscribe(f => {
        this.moveFolder(f);
      }),
      this.mainService.folderDeleteSub.subscribe(f => {
        this.folderDelete(f);
      }),
      this.mainService.startAdHocFolderSub.subscribe(value => {
        this.startAdHocFolder(value.folder, value.transformType);
      }),
    );

    // search files / folders
    this.searchFilesFolder();
    /*   gapi.load(
         'picker'
         , function () {
         }
       );
       gapi.load('auth', function () {
       });*/

    this.mainService.isDialog = this.isDialog;
    this.mainService.dataType = this.dataType;
  }

  selectTab ( what:string ) {
    this.selectedTab = what;
  }

  searchFilesFolder() {
    this.searchCont.valueChanges.pipe(debounceTime(1500)).subscribe(s => {
      this.mainService.searchFilesFolder.next(s);
    });
  }

  searchFilesFolderWithoutGlobal() {
    setTimeout(() => {
        this.mainService.searchFilesFolderWithoutGlobal.next();
      },
      1500);
  }

  onReady() {
    this.adHocF = []
    this.mainService.adHocF = this.adHocF;
    this.fourD.datasetTypes.forEach(d => d._adhocTransforms.filter(tt => tt && !tt['needsInput'] && tt['folderWorthy']).forEach(t => this.adHocF.push(t)))
    this.mainService.adHocF = this.adHocF;
    var accountMeta = this.service.objectMetas.find(o => o.uid == 'Dataset')
    this.canAddFile = !!accountMeta && (!!accountMeta.acl.find(p => p == 'api_create') || !!Object.keys(accountMeta.account_acl).find(k => !!accountMeta.account_acl[k].find(p => p == 'api_create' || p == 'asset_create')))
    var accountMeta2 = this.service.objectMetas.find(o => o.uid == 'Folder')
    this.canAddFolder = !!accountMeta2 && (!!accountMeta2.acl.find(p => p == 'api_create') || !!Object.keys(accountMeta2.account_acl).find(k => !!accountMeta2.account_acl[k].find(p => p == 'api_create' || p == 'asset_create')))
    this.folderXforms = this.fourD.transformTypes.filter(tt => tt.isFolder)

    this.fourD.V.searchByObject(Folder).limit(1).queryObservable().subscribe(s =>
      this.folderCountCheck(s.items.length)
    )

    this.fourD.V.searchByObject(Folder).equals('name', MainService.GOOGLE_DRIVE).limit(1).queryObservable().subscribe(s =>
      this.googleFolder = s.items[0]
    )


  }

  helloDrop(e, entering) {
    this.mainService.isOver = entering

  }

  dragOver(e: DragEvent) {
    e.preventDefault()
    this.mainService.isOver = true
    return false
  }

  selectRoot(s: Folder) {
    this.rootFolder = s
    this.mainService.rootFolder = this.rootFolder;
  }

  selectFolder(f: Folder) {
    this.folderSelected.emit(f)
    /*
    const mainDiv = document.getElementById('ExplorerComponentMainDIV');
    if (mainDiv && mainDiv != null) {
      mainDiv.scrollTop = 0;
    }
    */
    const mainDiv1 = document.getElementById('AppDialogMainDIV');
    if (mainDiv1 && mainDiv1 != null) {
      mainDiv1.scrollTop = 0;
    }
    // document.body.scrollTop = 0;
    // window.scroll(0, 0);
    if (!f && this.treeComponent ) {
      this.rootFolder = this.treeComponent.dataSource.data.find(d => d.item['root'] == 'myFiles').item
      this.mainService.rootFolder = this.rootFolder;
    }

    this.selectedFolder = f || this.rootFolder
    this.mainService.selectedFolder = this.selectedFolder;


    this.specialActions = this.fourD.transformTypes.filter(tt =>
      f && f.transform && tt.isSubTransform && (tt.isSubTransform.id == f.transform.id)
    )

    if (this.fileListComponent)
      this.fileListComponent.selectedFiles = []

    if (!f) {

    }
    else if (f['root'] == 'myFiles') {
      this.files = {
        op: 'and',
        items: [{
          col: 'folder', op: '=', isNull: true
        },
          {
            col: 'account', op: '=', val: this.fourD.activeTeam.id
          }
        ]
      }
    }
    else if (f['root'] == 'shared') {
      this.files = {
        op: 'and',
        items: [{
          col: 'folder', op: '=', isNull: true
        },
          {
            col: 'account', op: 'in', ids: [this.fourD.activeTeam.id, this.fourD.sampleAccount.id], not: true
          }
        ]
      }
    }
    else if (f['root'] == 'sample') {
      this.files = {
        op: 'and',
        items: [{
          col: 'folder', op: '=', isNull: true
        },
          {
            col: 'account', op: '=', val: this.fourD.sampleAccount.id
          }
        ]
      }
    } else if (f['root'] == 'google-drive') {
      if (this.googleFolder) {
        this.selectedFolder = this.googleFolder;
        this.files = {
          col: 'folder', op: '=', val: this.googleFolder.id
        }
      }
    } else if (f['root'] == 'dropbox') {
      if (this.dropboxFolder) {
        this.selectedFolder = this.dropboxFolder;
        this.files = {
          col: 'folder', op: '=', val: this.dropboxFolder.id
        }
      }
    }
    else {
      this.files = {
        col: 'folder', op: '=', val: f.id
      }
    }

  }


  setSelection(items: Dataset[]) {
    this.filesSelected.emit(items)
    if (items.length == 1 && items[0].dataType) {
      // dont show processing buttons when files in saplce project are viewed
      this.adHocs = items[0].account.id == this.fourD.sampleAccount.id ? [] : items[0].dataType._adhocTransforms
    }
    else {
      this.adHocs = []
    }
  }

  newFolder(parent?: Folder) {
    var inp = {value: ''}
    this.openDialog('FILE_LIST.NAV.NEW_FOLDER_TITLE', 'FILE_LIST.NAV.NEW_FOLDER_TEXT', null, null, inp).subscribe(res => {
      if (res) {
        this.fourD.V.searchByObject(Folder).equals('name', res)
          .equals('parent', parent['root'] ? null : parent).queryObservable().subscribe(value => {
          if (value && value.items.length > 0) {
            this.openSnackBarError('FILE_LIST.NAV.FOLDER_EXIST');
          } else {
            var v = new Folder(this.fourD.V)
            v.name = res
            v.parent = parent['root'] ? null : parent
            v.saveObservable().subscribe(
              s => {
                this.treeComponent.refresh(null);
                this.selectFolder(v);
              },
              e => this.openSnackBarError(e.message, null)
            )
          }
        });

      }
    })
  }

  /**
   "DIALOG":{
                "RENAME_FOLDER_TITLE":"Rename Folder",
                "RENAME_FOLDER_TEXT":"Enter the new name for this folder",
                "RENAME_FILE_TITLE":"Rename File",
                "RENAME_FILE_TEXT":"Enter the new name for this file",
                "MOVE_FOLDER_TITLE":"Move Folder",
                "MOVE_FOLDER_TEXT":"Select the destination folder to move this folder to",
                "MOVE_FILE_TITLE":"Move File",
                "MOVE_FILE_TEXT":"Select the destination folder to move this file to",
                "MOVE_FILES_TITLE":"Move Files",
                "MOVE_FILES_TEXT":"Select the destination folder to move {{ count }} files to"
            },*/

  renameFile(f: Dataset) {
    var inp = {value: f.name}
    this.openDialog('FILE_LIST.RENAME.FILE_TITLE', 'FILE_LIST.RENAME.FILE_TEXT', 'GENERIC.OK', 'GENERIC.CANCEL', inp)
      .subscribe(res => {
        if (res) {
          f.name = res
          f.saveObservable().subscribe(
            s => {
              this.openSnackBarSuccess('GENERIC.SAVED', null);
              this.mapService.currentProject = null
            },
            e => this.openSnackBarError(e.message, null)
          )
        }
      })
  }

  rename(f: Folder) {
    var inp = {value: f.name}
    this.openDialog('FILE_LIST.RENAME.FOLDER_TITLE', 'FILE_LIST.RENAME.FOLDER_TEXT', 'GENERIC.OK', 'GENERIC.CANCEL', inp)
      .subscribe(res => {
        if (res) {
          f.name = res
          f.saveObservable().subscribe(
            s => this.openSnackBarSuccess('GENERIC.SAVED', null),
            e => this.openSnackBarError(e.message, null)
          )
        }
      })
  }

  editFolderProperties(f: Folder) {
    console.log ( '!!!!', f );
    var inp = {
      folder_properties: [ { key:'name', value:f.name, type:'text' }, { key:'id', value:f.id }, { key:'isMyAppRoot', value:false, type:'check' } ] 
    };
    this.openDialog('FILE_LIST.FOLDER_PROPERTIES', '', 'GENERIC.OK', 'GENERIC.CANCEL', inp )
      .subscribe(res => {
        if (res) {
          // console.log ( '!!!!', res );
        }
      })
  }

  moveFiles(d: Dataset[]) {

    this.openDialogWithMode('folder', 'FILE_LIST.MOVE.FILE_TITLE', 'FILE_LIST.MOVE.FILE_TEXT').subscribe(dest => {
      if (dest) {
        forkJoin(d.map(dd => {
          dd.folder = dest['root'] ? null : dest
          return dd.saveObservable()
        })).subscribe(
          s => {
            this.fileListComponent.refresh()
            this.openSnackBarSuccess('GENERIC.MOVED', null)
          },
          e => this.openSnackBarError(e.message, null)
        )
      }
    })
  }

  moveFolder(f: Folder) {

    this.openDialogWithMode('folder', 'FILE_LIST.DIALOG.MOVE_FILE_TITLE', 'FILE_LIST.DIALOG.MOVE_FILE_TEXT').subscribe(dest => {
      if (dest) {
        f.parent = dest['root'] ? null : dest
        f.saveObservable().subscribe(
          s => {
            this.treeComponent.refresh(null)
            this.openSnackBarSuccess('GENERIC.SAVED', null)
          },
          e => this.openSnackBarError(e.message, null)
        )
      }
    })

  }

  showFolder() {
    let dialogRef = this.dialog.open(AppDialog, {
      width: '80%',

      data: {mode: 'folder'}
    });

    return dialogRef.afterClosed()
  }

  forceDelete(selected: Dataset[]) {
    var okMSg, errMsg
    this.translate.get(['FILE_LIST.DELETE.SUCCESS', 'FILE_LIST.DELETE.ERROR']).pipe(map(params => {
      okMSg = params['FILE_LIST.DELETE.SUCCESS']
      errMsg = params['FILE_LIST.DELETE.ERROR']
    }), mergeMap(e => {
      return this.openDialogWithMeta(selected.length != 1 ? {count: selected.length} : {file: selected[0].name},
        'FILE_LIST.DELETE.TITLE', selected.length > 1 ? 'FILE_LIST.DELETE.MSG_MANY' : 'FILE_LIST.DELETE.MSG',
        'GENERIC.YES', 'GENERIC.NO').pipe(
        flatMap(s => {
          if (s) {
            this.fileListComponent.loading = true
            return forkJoin(selected.map(ss => ss.destroyObservable()))
          }
          else {
            return observableOf([])
          }
        })
      )
    }),)
      .subscribe(
        s => {
          if (s.length)
            this.openSnackBarSuccess(okMSg, null, {count: s.length});

          this.incomingData.removeAll(selected); // refactoring the below lines / rigmarole

          if (this.mapService.datasetForLayers.length > 0) {
            // note: we should NOT access directly here; rewrite into own service, or at least mapService.deleteIncoming(selected)
            this.mapService.datasetForLayers = this.mapService.datasetForLayers.filter(data => selected.findIndex(sd => sd.id === data.id) === -1);
          }
          this.fileListComponent.loading = false
          this.fileListComponent.selectedFiles = []
          this.fileListComponent.refresh()
        },
        e => this.openSnackBarError(errMsg, null, {msg: e.message}),
      )

  }

  folderDelete(f: Folder) {
    var okMSg, errMsg
    this.translate.get(['FOLDER.DELETE.SUCCESS', 'FOLDER.DELETE.ERROR']).pipe(map(params => {
      okMSg = params['FOLDER.DELETE.SUCCESS']
      errMsg = params['FOLDER.DELETE.ERROR']
    }), mergeMap(e => {
      return this.openDialogWithMeta({name: f.name}, 'FOLDER.DELETE.TITLE', 'FOLDER.DELETE.MSG', 'GENERIC.YES', 'GENERIC.NO').pipe(
        flatMap(s => {
          if (s) {

            return f.destroyObservable().pipe(map(_ => true))
          }
          else {
            return observableOf(null)
          }
        })
      )
    }),).subscribe(
      s => {
        if (s) {
          this.openSnackBarInfo(okMSg, null)
          this.treeComponent.refresh(null)
          this.selectedFolder = this.treeComponent.dataSource.data.find(d => d.item['root'] == 'myFiles').item
          this.mainService.selectedFolder = this.selectedFolder;
          this.fileListComponent.dataSource.injectVals([], true);
        }
      },
      e => this.openSnackBarError(errMsg, null, {msg: e.message})
    )
  }

  viewItem(i: Transform[], force?: boolean, d?: Dataset) {
    if (this.isDialog) return
    var supportedTypes = ['photo-dzi', 'tms', 'three-d-tiles', 'terrain-tiles', 'kml', 'geo-json','public-3d']

    if (this.dataType != 'Dataset' || force) {
      var t: Transform = i.find(i => !!supportedTypes.find(s => i.transformType.uid == s))
      if (t == null && d.dataType && d.dataType.uid === 'photo') {
        this.applyTransform(d);
        this.openSnackBarInfo('DIALOG.ZOOM_LEVEL')
        return
      } else if (d && d.dataType && d.dataType.uid === 'kml') {
        this.openMapDialogWithItems(d, [], 'DIALOG.MAP').subscribe()
      } else if (t == null) {
        this.openSnackBarInfo('DIALOG.PREVIEW_FOR_PHOTO')
        return
      }
      else if (t.status == 'processing') {
        this.openSnackBarWarn('DIALOG.FILE_PROCESSING')
        return
      } else if (t.transformType.uid == 'photo-dzi') {
        this.openDZIDialogWith(t, 'DIALOG.DZI').subscribe()
      }
      else
        this.openMapDialogWithItems(d, [t], 'DIALOG.MAP').subscribe()
    }
    else {
      this.fourD.V.searchByObject(Transform).equals('input', i[0]).sortBy('id', true).queryObservable().subscribe(s => this.viewItem(s.items, true, <any>i[0]))
    }
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe())
  }
  startAdHoc2(a:any[]){
    this.startAdHoc(a[0],a[1],false,null)
  }
  startAdHoc(d: Dataset, tt: TransformType, isNew: boolean, ttBatch: Folder) {

    var startTheThing = () => {
      this.service.startAdHoc(this.dialog,d,tt,isNew,ttBatch).subscribe(_ => {
        if (isNew) {
          this.selectFolder(d.folder)
          this.treeComponent.treeControl.expandDescendants(this.treeComponent.currentNode)
          this.treeComponent.dataSource.database.getChildren(this.treeComponent.currentNode)
        }
      }, 
      e => this.openDialog('FILE_LIST.DIALOG.TRANSFORM_ERROR', e.message))

    }

    // TODO Alex, this is just a quick n dirty
    d.quoteTransform(tt).subscribe(amount => {

      if(amount.amount)
      this.translate.get('FILE_LIST.DIALOG.TRANSFORM_USE',{cost:amount.amount}).subscribe(ss => 
        this.openDialog('FILE_LIST.DIALOG.TRANSFORM_COST',ss,'GENERIC.OK','GENERIC.CANCEL').subscribe(s => {
          if(s){
            startTheThing()
          }
        })
        )
        
      else
        startTheThing()
    }
    ,
    e => 
    startTheThing()
    //this.openSnackBarError('Error ' + e.message)
    )
    // SJ Moved this into service
/*
    tt.apis.queryObservable().subscribe(res => {

      var onReady: Observable<any> = null

      var model = d['processingDefaultArgs'] || {}
      
      console.log(model)
      // when theres account specific ProcessorAPIs
      if (res.items.length) {
        // TODO: for now just do first one
        var api = res.items[0]
       
        onReady = api.needsInput || res.items.length > 1 ? this.showInputDialog(model, res.items, tt) : observableOf({
          api: api,
          model: {}
        })

      }

      // otherwise default transformType
      else {
        onReady = tt['needsInput'] || res.items.length > 1 ? this.showInputDialogForT(model, tt) : observableOf({model: model})
      }


      onReady.subscribe(params => {

        if (!params) {
          if (isNew) d.destroyObservable().subscribe()
          return
        }

        if (ttBatch)
          params.model.batch_id = 'folder_' + ttBatch.id

        // when its an api specific tak that to end otherwise default
        //var extraURL = params.api ? ('/' + params.api.id) : ''

        d.applyTransform(tt, params.model).subscribe(s => {
            if (isNew) {
              this.selectFolder(d.folder)
              this.treeComponent.treeControl.expandDescendants(this.treeComponent.currentNode)
              this.treeComponent.dataSource.database.getChildren(this.treeComponent.currentNode)
            }
          }
          ,
          e => this.openSnackBarError('Error ' + e.message)
        )

      })

    })
*/
  }

  doXform(t: TransformType, byoFolder: Folder) {
    var obs = observableOf(byoFolder)
    if (!byoFolder) {
      var f = new Folder(this.fourD.V).set({
        name: 'Results ' + M(new Date()).format('DD-MM-YY HH:mm'),
        transform: t
      })
      f.parent = this.selectedFolder
      obs = f.saveObservable()

    }

    obs.subscribe(f => {
        var d = new Dataset(this.fourD.V)
        d.name = t['primary_file'] || this.selectedFolder.name + ' ' + t.name
        d.folder = f

        d.dataType = this.fourD.datasetTypes.find(d => d.id == t.createType.id)
        d.saveObservable().subscribe(s =>
            this.startAdHoc(d, t, true, f)
          ,
          e => this.openSnackBarError('GENERIC.ERROR ' + e.message)
        )
      },
      e => this.openSnackBarError('GENERIC.ERROR ' + e.message)
    )
  }

  showInputDialog(model: any, apis: ProcessorAPI[], tt: TransformType) {
    let dialogRef = this.dialog.open(APIDialog, {
      minWidth:'350px',
      // height: '80%',
      data: {model: model, apis: apis, title: 'TYPES.' + tt.uid}
    });

    return dialogRef.afterClosed()
  }

  showInputDialogForT(model: any, tt: TransformType) {
    let dialogRef = this.dialog.open(APIDialog, {
      minWidth:'350px',

      // height: '80%',
      data: {model: model, apis: [tt], title: 'TYPES.' + tt.uid}
    });

    return dialogRef.afterClosed()
  }

  folderCountCheck(count) {
    if (!count) {
      /* let dialogRef = this.dialog.open(EmptyDialog, {
         width: '80%',

         data: {}
       });

       return dialogRef.afterClosed()*/
    }
  }

  processorCheck(count) {
    let MAX_COUNT = 4
    this.showProcessor = count >= MAX_COUNT
  }

  /*plotItemOnCesium(i: Transform[], force: boolean, d?: Dataset) {
    let transform = [];
    var v;
    i.forEach(
      value => {
        transform.push(this.fourD.V.searchByObject(Transform).equals('input', value).sortBy('id', true).queryObservable()
        );
      }
    );
    forkJoin(transform)
      .subscribe(res => {
          this.openMapDialogPlotAllWithItems(d, res, 'DIALOG.GENERATE_QUICK_VIEW', this.selectedFolder).subscribe()
        },
        e => console.log(e)
      )


    // this.openMapDialogPlotAllWithItems(d,i,"DIALOG.MAP").subscribe()

    /!* var supportedTypes = ['photo-dzi','tms','three-d-tiles']

     if(this.dataType != 'Dataset' || force){
       var t:Transform = i.find(i => !!supportedTypes.find(s => i.transformType.uid == s))
       /!*if(t == null){
         this.openSnackBarError('This file has no preview')
         return
       }
       else if(t.status == 'processing'){
         this.openSnackBarWarn('This file is still processing')
         return
       }
       if(t.transformType.uid == 'photo-dzi'){
         this.openDZIDialogWith(t,"DIALOG.DZI").subscribe()
       }
       else*!/
         this.openMapDialogPlotAllWithItems(d,i,"DIALOG.MAP").subscribe()
     }
     else{
       this.fourD.V.searchByObject(Transform).equals('input',i[0]).sortBy('id',true).queryObservable().subscribe(s => this.plotItemOnCesium(i,true,<any>i[0]))
     }*!/
  }*/

  startAdHocFolder(f: Folder, xform: TransformType) {
    this.fourD.V.api('/app/Account/' + this.fourD.activeTeam.id + '/api/Folder/bulk/' + f.id + '/' + xform.uid + '?access_token=' + this.fourD.V.token, 'post',{}).subscribe(s => this.openSnackBarInfo('DIALOG.FOLDER_TASK')
      , e => this.openSnackBarError(e.message))

  }

  CLIENT_ID = '260359117038-se34e621jd2elb991fo7d59qdhk99d6p.apps.googleusercontent.com';
  API_KEY = 'AIzaSyCoOqrihdpabwuoFn5zwCdoXl--6_sqUYc';
  DISCOVERY_DOCS = ['https://www.googleapis.com/discovery/v1/apis/drive/v3/rest'];
  SCOPES = 'https://www.googleapis.com/auth/drive';
  pickerApiLoaded = false;
  oauthToken?: any;

  /*
  onAuthApiLoad() {
    gapi.auth.authorize(
      {
        'client_id': this.CLIENT_ID,
        'scope': this.SCOPES,
        'immediate': false
      },
      this.handleAuthResult);
  }

  onPickerApiLoad() {
    this.pickerApiLoaded = true;
    this.createPicker();
  }

  handleAuthResult(authResult) {
    if (authResult && !authResult.error) {
      if (authResult.access_token) {
        var pickerBuilder = new google.picker.PickerBuilder();
        var picker = pickerBuilder.enableFeature(google.picker.Feature.NAV_HIDDEN).setOAuthToken(authResult.access_token).addView(google.picker.ViewId.PHOTOS).setDeveloperKey('AIzaSyDFf3LoI2iGoq21Py5mx0YdRZC4-wOu2jQ').setCallback(function (e) {
          var url = 'nothing';
          console.log(url);
          if (e[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
            var doc = e[google.picker.Response.DOCUMENTS][0];
            url = doc[google.picker.Document.URL];
          }
          var message = 'You picked: ' + url;
          console.log(message);
        }).build();
        picker.setVisible(true);
      }
    }
  }*/

  /*
    createPicker() {

      if (this.pickerApiLoaded && this.oauthToken) {
        let DocsView = new google.picker.DocsView();
        DocsView.setParent('root')
        DocsView.setIncludeFolders(true);
        DocsView.setSelectFolderEnabled(true);
        let DocsUploadView = new google.picker.DocsUploadView();
        DocsUploadView.setIncludeFolders(true);
        this.bindedPickerCallback = this.pickerCallback.bind(this);
        var picker = new google.picker.PickerBuilder().addView(DocsView).addView(DocsUploadView).enableFeature(google.picker.Feature.MULTISELECT_ENABLED).setOAuthToken(this.oauthToken).setDeveloperKey(this.API_KEY).setCallback(this.bindedPickerCallback).build();
        picker.setVisible(true);
      }
    }

    pickerCallback(data) {
      let fileList = [];
      let folderList = [];
      let accessToken;

      if (data[google.picker.Response.ACTION] == google.picker.Action.PICKED) {
        let i = 0;
        accessToken = gapi.auth.getToken().access_token;
        this.totalDownloadableItem = data[google.picker.Response.DOCUMENTS].length;
        this.downloadUrlTried = 0;
        this.googleDatasetsList = [];
        data[google.picker.Response.DOCUMENTS].forEach(pickedItem => {
            i++;
            if (pickedItem.type === 'folder') {
              this.totalDownloadableItem--;
              console.log('folder selected ' + pickedItem.name);

              this.fourD.V.searchByObject(Folder).equals('name', pickedItem.name)
                .equals('parent', this.googleFolder).queryObservable().subscribe(folder => {
                if (folder && folder.items.length > 0) {
                  let n = new Folder(this.fourD.V);
                  n.name = pickedItem.name + ' ' + new Date();
                  n.parent = this.googleFolder;
                  n.saveObservable().subscribe(
                    s => {
                      this.getFileListAndDownload(pickedItem, s);
                      this.treeComponent.refresh(null);
                    });
                  // this.getFileListAndDownload(pickedItem, folder.items[0]);
                } else {
                  let n = new Folder(this.fourD.V);
                  n.name = pickedItem.name;
                  n.parent = this.googleFolder;
                  n.saveObservable().subscribe(
                    s => {
                      this.getFileListAndDownload(pickedItem, s);
                      this.treeComponent.refresh(null);
                    });
                }
              });
            } else {

              this.getDownloadUrlFromGoogleDrive(pickedItem, undefined, data[google.picker.Response.DOCUMENTS].length === i);
            }

          }

        )

      }

    }

    private getFileListAndDownload(pickedItem, folder, nextPageToken?: any) {
      let request;
      if (nextPageToken) {
        request = gapi.client.drive.files.list({
          q: `'${pickedItem.id}' in parents and trashed = false`,
          pageToken: nextPageToken
        });
      } else {
        request = gapi.client.drive.files.list({
          q: `'${pickedItem.id}' in parents and trashed = false`
        });
      }
      request.execute(file => {
          console.log('file[files].length', file['files'].length);
          if (file['nextPageToken']) {
            this.getFileListAndDownload(pickedItem, folder, file['nextPageToken']);
            this.totalDownloadableItem += file['files'].length;
            file['files'].forEach(f => {
              if (f.mimeType === 'application/vnd.google-apps.folder') {
                this.totalDownloadableItem--;
              } else {
                this.getDownloadUrlFromGoogleDrive(f, folder, false);
              }
            });
          } else {
            let i = 0;
            this.totalDownloadableItem += file['files'].length
            file['files'].forEach(f => {
              i++;
              if (f.mimeType === 'application/vnd.google-apps.folder') {
                this.totalDownloadableItem--;
              } else {
                this.getDownloadUrlFromGoogleDrive(f, folder, file['files'].length === i);
              }
            });
          }

        }
      );
    }

    private setGoogleDriveFolder() {
      if(this.googleFolder){
        this.treeComponent.selectedFolder = this.googleFolder;
        this.selectFolder(this.googleFolder);
      }
    }

    private setDropboxFolder() {
      if(this.dropboxFolder){
        this.treeComponent.selectedFolder = this.dropboxFolder;
        this.selectFolder(this.dropboxFolder);
      }
    }

    private createOrGetGoogleDriveFolder() {
      this.fourD.V.searchByObject(Folder).equals('name', MainService.GOOGLE_DRIVE)
        .equals('parent', null).queryObservable().subscribe(value => {
        if (value && value.items.length > 0) {
          this.googleFolder = value.items[0];
          this.mainService.googleFolder = this.googleFolder;

        } else {
          this.googleFolder = new Folder(this.fourD.V);
          this.googleFolder.name = MainService.GOOGLE_DRIVE;
          this.googleFolder.saveObservable().subscribe(
            s => {
              this.mainService.googleFolder = this.googleFolder;
              this.treeComponent.refresh(null);
            });
        }
      });
    }

    private createOrGetDropboxFolder() {
      this.fourD.V.searchByObject(Folder).equals('name', MainService.DROPBOX)
        .equals('parent', null).queryObservable().subscribe(value => {
        if (value && value.items.length > 0) {
          this.dropboxFolder = value.items[0];
          this.mainService.dropboxFolder = this.dropboxFolder;

        } else {
          this.dropboxFolder = new Folder(this.fourD.V);
          this.dropboxFolder.name = MainService.DROPBOX;
          this.dropboxFolder.saveObservable().subscribe(
            s => {
              this.mainService.dropboxFolder = this.dropboxFolder;
              this.treeComponent.refresh(null);
            });
        }
      });
    }

    private getDownloadUrlFromGoogleDrive(file, folder?: Folder, isLast?: boolean) {
      var request = gapi.client.request({
        path: '/drive/v2/files/' + file.id,
        method: 'GET',
        params: {
          alt: 'json', // or xml, w/e you prefer
          key: this.API_KEY,
          access_token: gapi.auth.getToken().access_token,
        },
      }).execute(fileResponse => {
          if (fileResponse['error'] && fileResponse['error']['message'].indexOf('User Rate Limit Exceeded') !== -1) {
            console.log('error occured', file.id);
            setTimeout(() => {
                console.log('retry now timeout', file.id);
                this.getDownloadUrlFromGoogleDrive(file, folder, isLast);
              },
              Math.pow(2, Math.floor(Math.random() * 5) + 1) + Math.random());
          } else if (fileResponse['downloadUrl']) {
            console.log('got file', file.id);
            this.downloadUrlTried++;
            if (this.googleFolder) {
              if (folder) {
                this.createDatasetForGoogleDrive(fileResponse, folder, isLast);
                // this.treeComponent.refresh(null);
              } else {
                this.createDatasetForGoogleDrive(fileResponse, this.googleFolder, isLast);
                // this.treeComponent.refresh(null);
              }
            }
          } else {
            this.downloadUrlTried++;
            console.log('could not get downloadUrl nor error', file.id);
            if (this.downloadUrlTried >= this.totalDownloadableItem) {
              console.log('getDownloadUrlFromGoogleDrive downloadUrlTried ', this.downloadUrlTried);
              console.log('getDownloadUrlFromGoogleDrive totalDownloadableItem ', this.totalDownloadableItem);
              this.sendRequestToCreateDatasetsGoogleDrive();
            }
          }
        }
      );
    }

    private createDatasetForGoogleDrive(file, v, isLast?: boolean) {
      let blank = {
        name: file['originalFilename'],
        folder: v.id,
        incomplete: true,
        google_downloadUrl: file['downloadUrl'],
        google_access_token: gapi.auth.getToken().access_token
      };
      // )
      // blank['google_downloadUrl'] = file['downloadUrl'];
      // blank['google_access_token'] = gapi.auth.getToken().access_token;
      this.googleDatasetsList.push(blank);
      if (this.downloadUrlTried === this.totalDownloadableItem) {
        console.log('createDatasetForGoogleDrive downloadUrlTried ', this.downloadUrlTried);
        console.log('createDatasetForGoogleDrive totalDownloadableItem ', this.totalDownloadableItem);
        this.sendRequestToCreateDatasetsGoogleDrive();
      }

    }

    private createDatasetForDropbox(file, v) {
      let blank = {
        name: file['name'],
        folder: v.id,
        incomplete: true,
        dropbox_downloadUrl: file['link'].replace("?dl=0","?dl=1"), // hack to download file
        isDir : file['isDir']
      };
      this.dropboxDatasetsList.push(blank);
    }

    googleAuth: gapi.auth2.GoogleAuth;

    openGoogleDrive() {
      this.setGoogleDriveFolder();
      if (this.oauthToken) {
        this.createPicker();
      } else {

        new Promise((resolve, reject) => {

          gapi.load(
            'client:auth2', () => {
              return gapi.client.init({
                apiKey: this.API_KEY,
                clientId: this.CLIENT_ID,
                discoveryDocs: this.DISCOVERY_DOCS,
                scope: this.SCOPES,
              }).then(() => {
                this.googleAuth = gapi.auth2.getAuthInstance();
                resolve();
              });
            });
        }).then(value => {
          this.googleAuth.signIn({
            prompt: 'consent'
          }).then((googleUser: gapi.auth2.GoogleUser) => {
            // this.appRepository.User.add(googleUser.getBasicProfile());
            this.pickerApiLoaded = true;
            this.oauthToken = gapi.auth.getToken().access_token;
            this.createPicker();
          });

        });
      }

    }

    openDropBox() {
      var options = {

        // Required. Called when a user selects an item in the Chooser.
        success:  (files) => {
          // alert('Here\'s the file link: ' + files[0].link);
          console.log(files);
          this.dropboxDatasetsList = [];
          if(files && files.length > 0){
            files.forEach(file => {
              this.createDatasetForDropbox(file, this.dropboxFolder)
            })
            this.sendRequestToCreateDatasetsDropbox();
          }


        },

        // Optional. Called when the user closes the dialog without selecting a file
        // and does not include any parameters.
        cancel: function () {

        },

        // Optional. "preview" (default) is a preview link to the document for sharing,
        // "direct" is an expiring link to download the contents of the file. For more
        // information about link types, see Link types below.
        linkType: 'preview', // or "direct"

        // Optional. A value of false (default) limits selection to a single file, while
        // true enables multiple file selection.
        multiselect: true, // or true

        // Optional. This is a list of file extensions. If specified, the user will
        // only be able to select files with these extensions. You may also specify
        // file types, such as "video" or "images" in the list. For more information,
        // see File types below. By default, all extensions are allowed.
        // extensions: ['.pdf', '.doc', '.docx'],

        // Optional. A value of false (default) limits selection to files,
        // while true allows the user to select both folders and files.
        // You cannot specify `linkType: "direct"` when using `folderselect: true`.
        folderselect: true, // or true

        // Optional. A limit on the size of each file that may be selected, in bytes.
        // If specified, the user will only be able to select files with size
        // less than or equal to this limit.
        // For the purposes of this option, folders have size zero.
        // sizeLimit: 1024, // or any positive number
      };

      // this.dropboxButton = Dropbox.createChooseButton(options);
      Dropbox.choose(options);
      // this.dropboxButton.onclick =  this.dropboxButtonClickHandler.bind(this);
      // document.getElementById("container").appendChild(this.dropboxButton);
      this.setDropboxFolder();
    }

    private dropboxButtonClickHandler(){
      this.setDropboxFolder();
    }

    private sendRequestToCreateDatasetsGoogleDrive() {
      this.fourD.V.api('/api/Folder/' + this.googleFolder.id + '/googleUpload', 'post', {
        datasetsList: this.googleDatasetsList
      }).subscribe(s => {
        this.openSnackBarSuccess('Request sent to create datasets');
        this.waitForGoogleFinishSocket();
      });
    }

    private sendRequestToCreateDatasetsDropbox() {
      this.fourD.V.api('/api/Folder/' + this.dropboxFolder.id + '/dropboxUpload', 'post', {
        datasetsList: this.dropboxDatasetsList
      }).subscribe(s => {
        this.openSnackBarSuccess('Request sent to create datasets');
        this.waitForDropboxFinishSocket();
      });
    }

    private waitForGoogleFinishSocket() {
      this.fourD.onSocketCommand('google_finish').subscribe(value => {
        if (value && value.info.toLowerCase() === 'finished' || value.status.toLowerCase() === 'finished') {
          this.treeComponent.refresh(null);
        }

      });
    }

    private waitForDropboxFinishSocket() {
      this.fourD.onSocketCommand('dropbox_finish').subscribe(value => {
        if (value && value.info.toLowerCase() === 'finished' || value.status.toLowerCase() === 'finished') {
          this.treeComponent.refresh(null);
        }

      });
    }
    */
  ngAfterViewInit(): void {
    this.mainService.fileListComponent = this.fileListComponent;
    //this.createOrGetGoogleDriveFolder();
    //this.createOrGetDropboxFolder();
    // this.openDropBox();
  }

  private clickDropBox() {
    let inputElement: HTMLElement = document.getElementById('dropboxButton')  as HTMLElement;
    inputElement.click();
  }

  private applyTransform(d: Dataset | undefined) {
    if (this.fourD.transformTypes.find(t => t.uid == 'photo-dzi')) {
      d.applyTransform(this.fourD.transformTypes.find(t => t.uid == 'photo-dzi')).subscribe(s => {
        /*this.fourD.onSocketCommand('task_update').subscribe(value => {
          if (value.dataset.id === d.id && value.status === 'finished') {
          }else if(value.dataset.id === d.id && value.status ===  'failed'){
            this.openSnackBarError('DIALOG.CONVERSION_ERROR');
          }
        });*/
      })
    }

  }

  openSupportedFormatDialog() {
    this.openDialog('FILE_LIST.NAV.SUPPORTED_FORMAT', 'Geojson files in WGS84 (.json, .geojson) \n Geotiff Digital Terrain Model (.tif) \n Geotiff Imagery (.tif) \n Google Earth KM files (.kml) \n Photos (.jpg) \n Point Cloud and Scanner files (.las, .laz, .e57) \n Zipped Cesium 3D Tiles (.zip) \n Zipped GeoJPG files (.jpg, .jgw, .prj) \n Zipped Geotiff Imagery (.tif, .tfw, .prj) \n Zipped shape files (.shp, .prj, .dbf, .shx) \n Zipped 3D textured mesh model (.obj, .mtl and texture images)').subscribe()
  }
  setCRS(d:Dataset){
    let dialogRef = this.dialog.open ( AlignBoundsDialog, {
      width: '80%',
      data: {dataset: d }
    });

    dialogRef.afterClosed().subscribe(s => {

    })
    
  }

  folderDownload(f:Folder){
    document.location.href = this.service.V.config.host + '/api/Folder/' + f.id + '/download.zip?access_token=' + this.service.V.token
  }
}
